import { CSSProperties, FC } from 'react'
import { AnimatePresence, motion, Transition, Variants } from 'framer-motion'
import { cn } from '../../utils'

const shimmerStyle: CSSProperties = {
  backgroundImage:
    'linear-gradient(90deg, oklch(from var(--foreground) l c h / 0.5) 0%, oklch(from var(--foreground) l c h / 0.5) 40%, oklch(from var(--foreground) l c h / 0.8) 50%, oklch(from var(--foreground) l c h / 0.5) 60%, oklch(from var(--foreground) l c h / 0.5) 100%)',
  backgroundSize: '200% 100%',
  WebkitBackgroundClip: 'text',
  backgroundClip: 'text',
  color: 'transparent',
  animation: 'shimmer 1700ms ease-in-out infinite forwards',
}

export const loadingTextVariants: Variants = {
  initial: { opacity: 0, filter: 'blur(2px)' },
  animate: { opacity: 1, filter: 'blur(0px)' },
  exit: { opacity: 0, filter: 'blur(2px)' },
}

export const loadingTextTransition: Transition = { duration: 0.35 }

interface LoadingTextProps {
  text: string
  className?: string
  isLoading?: boolean
  /**
   * Framer-motion transition configuration (optional)
   */
  transition?: Transition
}

/**
 * Animated shimmer text that fades / slides when the `text` prop changes.
 */
export const LoadingText: FC<LoadingTextProps> = ({
  text,
  className = '',
  isLoading = true,
  transition = loadingTextTransition,
}) => {
  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.span
        key={text}
        variants={loadingTextVariants}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={transition}
        className={cn('inline-block', className)}
        style={isLoading ? shimmerStyle : undefined}
      >
        {text}
      </motion.span>
    </AnimatePresence>
  )
}
